import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/schoolSearch";
import deltas from "../../actions/deltas";

const {SET_SCHOOL_SEARCH_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.STATIC, SET_SCHOOL_SEARCH_STATE);
